jQuery(function($) {
  if($('.okeReviews-widget-holder').find('.okeReviews-reviewsWidget-reviewsAggregate.js-okeReviews-reviewsAggregateContainer').length > 0) {
    $('.okeReviews-widget-holder').css('visibility', 'visible');
    // Remove the placeholder
    $('.okeReviews-widget-holder').find('.okeReviews-placeholder').remove();
  }

  var productHeader = setInterval(function () {
    var product_header = jQuery('.product-header .h4.product-header__title');
    if (product_header.length > 0) {
        $('.template-product .section-header--related-product h2.section-header__title').show();
        clearInterval(productHeader);
    }
  }, 300);

  $(document).ready(function() {
    var modal_active = setInterval(function () {
      if ($('#board-customizer-selector.modal--active').length > 0 && $('.dbClick').length > 0) {
        if (!$('#board-customizer-selector.modal--active .boost-pfs-filter-tree-content').length) {
          $('#board-customizer-selector.modal--active button.modal__button').click()
          if ($('.board-customizer-components__item-add.dbClick').length > 0) {
            $('.board-customizer-components__item-add.dbClick').click()
          } else {
            $('.dbClick').parent().find('.board-customizer-components__item-add').click()
          }
        }
        clearInterval(modal_active);
      }
    }, 300);
  })
})

/**
 * Performance Optimization: Dynamic Script Loading for Okendo Reviews
 *
 * This implementation defers loading the Okendo reviews JavaScript until
 * the user scrolls within 200px of the reviews section.
 *
 * Benefits:
 * - Prevents review scripts from blocking the critical rendering path
 * - Allows LCP elements (product images, title, price) to load faster
 * - Reduces main thread blocking during initial page load
 * - Scripts load only when likely to be needed
 */
(function() {
  'use strict';

  // Configuration: Load script when reviews section is within 200px of viewport
  const ROOT_MARGIN = '200px';
  const THRESHOLD = 0.01;

  // Build script URL using Shopify CDN (defined in theme.liquid)
  const SCRIPT_URL = (typeof SHOPIFY_CDN !== 'undefined' ? SHOPIFY_CDN : '') + 'okendo-reviews.js?v=' + Date.now();

  // Flag to ensure we only load the script once
  let scriptLoaded = false;

  /**
   * Dynamically load the Okendo reviews script
   * Creates and appends a script tag to the document
   */
  function loadOkendoScript() {
    if (scriptLoaded) {
      return;
    }

    scriptLoaded = true;

    // Create script element
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.defer = true;
    script.async = true;

    // Add load handler for debugging
    script.onload = function() {
      console.log('✅ Okendo reviews script loaded successfully');

      // Show the reviews widget once script is loaded
      const reviewsHolder = document.querySelector('[data-oke-reviews-lazy-load="true"]');
      if (reviewsHolder) {
        reviewsHolder.style.visibility = 'visible';

        // Remove the placeholder
        const placeholder = reviewsHolder.querySelector('.okeReviews-placeholder');
        if (placeholder) placeholder.remove();

        // Trigger jQuery event if jQuery is available
        if (window.jQuery && window.jQuery('.okeReviews-widget-holder').length > 0) {
          window.jQuery('.okeReviews-widget-holder').trigger('content-visible');
        }
      }

      if (typeof performance !== 'undefined' && performance.mark) {
        performance.mark('okendo-reviews-script-loaded');
      }
    };

    script.onerror = function() {
      console.error('❌ Failed to load Okendo reviews script');
    };

    // Append to document
    document.head.appendChild(script);

    if (typeof performance !== 'undefined' && performance.mark) {
      performance.mark('okendo-reviews-script-requested');
    }
  }

  /**
   * Set up Intersection Observer to detect when reviews section approaches viewport
   */
  function setupLazyLoading() {
    const reviewsHolder = document.querySelector('[data-oke-reviews-lazy-load="true"]');

    if (!reviewsHolder) {
      console.log('ℹ️ No reviews widget found on this page');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !scriptLoaded) {
          console.log('🔍 Reviews section approaching viewport, loading script...');
          loadOkendoScript();
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: ROOT_MARGIN,
      threshold: THRESHOLD
    });

    observer.observe(reviewsHolder);

    console.log('✅ Okendo lazy loading observer registered');
  }

  /**
   * Initialize lazy loading when DOM is ready
   * Uses requestIdleCallback if available for better performance
   */
  function init() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        setupLazyLoading();
      }, { timeout: 2000 });
    } else {
      // Fallback for browsers without requestIdleCallback
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupLazyLoading);
      } else {
        setupLazyLoading();
      }
    }
  }

  // Start initialization
  init();
})();
